"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaceEvent = void 0;
var PlaceEvent;
(function (PlaceEvent) {
    PlaceEvent["updatedFacebookPage"] = "updatedFacebookPage";
    PlaceEvent["updatedTableTypes"] = "updatedTableTypes";
    PlaceEvent["updatedPlans"] = "updatedPlans";
    PlaceEvent["updatedContact"] = "updatedContact";
    PlaceEvent["updatedLayouts"] = "updatedLayouts";
    PlaceEvent["updatedHours"] = "updatedHours";
    PlaceEvent["updatedPlace"] = "updatedPlace";
    PlaceEvent["updatedPlaceLocalization"] = "updatedPlaceLocalization";
    PlaceEvent["updatedPlaceProfile"] = "updatedPlaceProfile";
    PlaceEvent["updatedReservationSetting"] = "updatedReservationSetting";
    PlaceEvent["updatedReservations"] = "updatedReservations";
    PlaceEvent["guestReservationRequest"] = "guestReservationRequest";
    PlaceEvent["updatedRealTimeReservations"] = "updatedRealTimeReservations";
    PlaceEvent["receiveReservationRequest"] = "receiveReservationRequest";
    PlaceEvent["subscriptionCreated"] = "subscriptionCreated";
})(PlaceEvent || (exports.PlaceEvent = PlaceEvent = {}));
//# sourceMappingURL=PlaceEvent.js.map